/**
 * NMS Product Discounts Component
 * Calculates and exposes discount data for other components
 * @extends NMSComponent
 */

// Define base NMS Component class if not already defined
window.NMSComponent =
  window.NMSComponent ||
  class {
    constructor(element) {
      this.element = element;
    }

    init() {}

    dispatchCustomEvent(eventName, detail = {}) {
      const event = new CustomEvent(`nms:${eventName}`, {
        detail: {
          component: this,
          element: this.element,
          ...detail,
          timestamp: Date.now(),
        },
        bubbles: true,
        cancelable: true,
      });

      this.element.dispatchEvent(event);
    }

    destroy() {}
  };

// Ensure NMS namespace exists
window.neemans = window.neemans || {};

/**
 * NMS Product Discounts Component
 */
class NMSProductDiscounts extends NMSComponent {
  static componentName = 'nms-product-discounts';

  constructor(element) {
    super(element);

    // Cache data attributes
    this.highestPercentage = parseFloat(this.element.dataset.highestDiscountPercentage || 0);
    this.lowestPrice = parseFloat(this.element.dataset.lowestCalculatedPrice || 0);
    this.lowestPriceFormatted = (this.element.dataset.lowestCalculatedPriceFormatted || '').replace('.00', '');
    this.originalPrice = parseFloat(this.element.dataset.originalPrice || 0);

    this.init();
  }

  init() {
    this.calculateDiscountData();
    this.exposeGlobalData();
    this.dispatchDiscountEvent();
  }

  calculateDiscountData() {
    this.discountData = {
      hasDiscount: this.highestPercentage > 0,
      percentage: this.highestPercentage,
      lowestPrice: this.lowestPrice,
      lowestPriceFormatted: this.lowestPriceFormatted,
      originalPrice: this.originalPrice,
      timestamp: Date.now(),
    };
  }

  exposeGlobalData() {
    // Set on window for global access (for compatibility)
    window.nmsLowestDiscountPrice = this.discountData;
  }

  dispatchDiscountEvent() {
    this.dispatchCustomEvent('discount-calculated', this.discountData);
  }

  // Public API methods
  getDiscountData() {
    return this.discountData;
  }

  refresh() {
    this.calculateDiscountData();
    this.exposeGlobalData();
    this.dispatchDiscountEvent();
  }
}

// Register component
window.neemans.NMSProductDiscounts = NMSProductDiscounts;

/**
 * Auto-initialization for product discounts components
 */
const initProductDiscountsComponents = () => {
  const components = document.querySelectorAll(
    '[data-nms-js="buybox-accordion"][data-accordion-type="discounts"]:not([data-product-discounts-initialized])'
  );
  components.forEach(component => {
    new NMSProductDiscounts(component);
    component.dataset.productDiscountsInitialized = 'true';
  });
};

// Initialize on DOM ready or immediately if already loaded
document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', initProductDiscountsComponents)
  : initProductDiscountsComponents();

// Re-initialize on dynamic content changes
document.addEventListener('shopify:section:load', initProductDiscountsComponents);

// Listen for color content updates and re-initialize within the updated container
document.addEventListener('nms:color-content-updated', event => {
  const { container, source } = event.detail;

  const components = container.querySelectorAll(
    '[data-nms-js="buybox-accordion"][data-accordion-type="discounts"]:not([data-product-discounts-initialized])'
  );
  components.forEach(component => {
    new NMSProductDiscounts(component);
    component.dataset.productDiscountsInitialized = 'true';
  });
});
